import React from "react"

import { LeadDocumentsTab } from "../../../Lead/LeadWorkspacePage/documents/LeadDocumentsTab.tsx"
import { TOUR_DEMO_LEAD_RECORD } from "../../content/tour-demo-data.ts"

/**
 * The REAL Lead Proposals & Contracts tab (`LeadDocumentsTab`). Rendered
 * `canEdit={false}` deliberately — unlike Overview/Scope, this tab's own
 * child components (`LeadViewProposals`/`LeadViewContracts`) dispatch some
 * of their actions (duplicate, send to client, submit for review) directly
 * via `useAppDispatch` rather than through the shared `onPatch` this demo
 * can safely intercept, so the create/action affordances stay hidden and
 * the tour shows the real, populated read view instead.
 */
export const DemoLeadDocumentsSection = () => (
  <LeadDocumentsTab lead={TOUR_DEMO_LEAD_RECORD} canEdit={false} />
)
